module.exports = __webpack_public_path__ + "img/标准文件3.a3d4cb21.png";